/**
 * @fileoverview Custom OpenLayers control for toggling the PDF viewer.
 * @module map/PdfViewerControl
 */

/**
 * Custom OpenLayers control that provides a button to toggle the PDF viewer panel.
 * Displays a book icon at the upper-left of the map.
 * @class
 * @extends ol.control.Control
 */
export class PdfViewerControl extends ol.control.Control {
    /**
     * Creates a new PdfViewerControl instance.
     * @param {Object} [options={}] - Control options
     * @param {Function} [options.onToggle] - Callback invoked when the button is clicked
     * @param {HTMLElement} [options.target] - Target element to render the control into
     */
    constructor(options = {}) {
        const button = document.createElement('button');
        button.innerHTML = '<i class="bi bi-book"></i>';
        button.className = 'ol-pdf-viewer-button';
        button.title = 'Toggle Case Book PDF Reader';

        const element = document.createElement('div');
        element.className = 'ol-pdf-viewer-control ol-unselectable ol-control';
        element.appendChild(button);

        super({
            element: element,
            target: options.target
        });

        this.onToggle = options.onToggle || (() => {});

        // Handle button click
        button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.onToggle();
        });
    }
}
